import { Component, Output, Input, EventEmitter, HostListener } from '@angular/core';

@Component({
  selector: 'playbook-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
})
export class DatePickerComponent {
  listOpen = false;
  chosenItem: any = false;
  private stopProp = false;
  @Input() isChoice = true;
  @Input() disableAll = false;
  @Input() displayProperty = 'name';
  @Input() items: any[];
  @Input() defaultCurrentTitle = '';
  @Output() item = new EventEmitter<any>();

  chooseItem(item) {
    this.item.emit(item);
    this.listOpen = false;

    if (!!this.isChoice) {
      this.chosenItem = item;
    }
  }

  toggleCalendar() {
    this.listOpen = !this.listOpen;
  }

  setTitle(title: string) {
    const item = {};
    item[this.displayProperty] = title;
    this.chosenItem = item;
  }

  setTitleDefault() {
    this.setTitle(this.defaultCurrentTitle);
  }

  clearSelection() {
    this.chosenItem = false;
    this.item.emit(null);
    this.listOpen = false;
  }

  @HostListener('body:click', ['$event'])
  bodyClicked(event) {
    if (this.stopProp === true) {
      this.stopProp = false;
      return;
    }

    this.listOpen = false;
  }

  @HostListener('click', ['$event'])
  clicked(event) {
    this.stopProp = event.currentTarget.contains(event.srcElement);
  }
}
